import { Button } from '@alf/uikit';
import {
  ACTION_LOCATIONS,
  LOG_ACTIONS,
  useLogAmplitude
} from '@namespace/analytics';
import { useGeneralRoutes } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import { useUserInfoLoaded } from '@namespace/user';

const RegisterButton = ({ className, buttonSize = 's' }) => {
  const { t } = useI18n();
  const { register } = useGeneralRoutes();
  const { isDesktop } = useDeviceStore();
  const { userInfoLoaded } = useUserInfoLoaded();
  const logAmplitude = useLogAmplitude();

  if (!userInfoLoaded) {
    return null;
  }

  return (
    <Button
      component={LocalizedLink}
      to={`${register}?from=${
        isDesktop ? ACTION_LOCATIONS.HEADER_DESKTOP : ACTION_LOCATIONS.HEADER
      }`}
      actionType="color1" // fe3.0 new theme fast fix, before was 'color3'
      size={buttonSize}
      className={className}
      dataRole="header-register-button"
      onClick={() => {
        logAmplitude({
          actionName: LOG_ACTIONS.REGISTRATION_OPEN,
          attributes: { entry_point: 'header' }
        });
      }}
    >
      {t('register.header')}
    </Button>
  );
};

export default RegisterButton;
